export const returnDefaultCalendarView = () => 'Monthly';
